module.exports = __webpack_public_path__ + "static/media/whatsapp-blue-icon.bb646504.svg";